@if (isAdmin) {
  <div>
    @if (loading) {
      <spinner id="loading" messageRelativePosition="bottom"> </spinner>
    }
    @if (!loading) {
      <div class="flx-container">
        @if (siteVisit) {
          <div class="flx-item">
            <ambasssador-listing-card [siteVisit]="siteVisit"> </ambasssador-listing-card>
          </div>
        }
        <div class="flx-break"></div>
        <div class="flx-item">
          <div>Choose Ambassador:</div>
          <div>
            <select class="form-control" [(ngModel)]="selectedAccount" [ngModelOptions]="{ standalone: true }">
              <!-- Safari Hack -- See https://stackoverflow.com/a/50418271/386619 -->
              <option disabled selected value="null">-- Choose Ambassador --</option>
              @for (item of externalAccounts; track item) {
                <option [ngValue]="item.userAccountId">{{ item.fullName }}</option>
              }
            </select>
          </div>
        </div>
        <div class="flx-break"></div>
        <div class="flx-item">
          <button [disabled]="!scheduleEnabled" class="btn btn-primary btn-round hvr-push" (click)="onScheduleClick()">Schedule</button>
        </div>
        <div class="flx-break"></div>
        <div class="flx-item">
          <a class="btn btn-default btn-round hvr-push" [routerLink]="['/ambassador']">Return to Ambassador Page</a>
        </div>
      </div>
    }
  </div>
}

@if (!isAdmin) {
  <div class="error-text">You are not authorized to view this page.</div>
}
